import axios from 'axios'
import router from '@/router'
import { Message } from 'element-ui'
axios.defaults.timeout = 10000
axios.defaults.withCredentials = true
axios.interceptors.request.use(
  (config) => {
    if (localStorage.getItem('token')) {
      config.headers.token = localStorage.getItem('token')
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)
axios.interceptors.response.use(
  (res) => {
    //获取状态码
    const status = res.data.code || res.status
    const message = res.data.msg || res.data.error_description || '未知错误'
      let url = '/api/zbSupplierApplicationInformation/supplierApplicationDetail'
    //如果在白名单里则自行catch逻辑处理
    //如果是401则跳转到登录页面
    if (status === 401) {
      this.$router.push('/Login')
    }
    if (status === 10006 || status === 10008) {
      localStorage.clear()
        router.push('/Login')
    }
      if (status === 10018 || status === 10019) {
          return res
      }
    // 如果请求为非200否者默认统一处理
    if (status !== 200 ) {
        Message({
          message: message,
          type: 'error'
        })
        return Promise.reject(new Error(message))
    }
    return res
  },
  (error) => {
    return Promise.reject(new Error(error))
  }
)
export default axios
